import { object } from 'prop-types'
import { kuiperClassNames } from '@opallabs/kuiper'
import PlaceholderContentListItem from '../ContentListItem/Placeholder'

const ContentPlaceholderList = ({ moment }) => (
  <div className={kuiperClassNames('contentPlaceholderList')}>
    {new Array(moment.postCount || 0).fill().map((n, idx) => (
      <PlaceholderContentListItem key={idx} />
    ))}
  </div>
)

ContentPlaceholderList.propTypes = {
  moment: object,
}

export default ContentPlaceholderList
